// ---------------------------------------------------------------------------
// GDPR-admin module — i18n messages (de-AT)
// ---------------------------------------------------------------------------

export const gdprAdminLocales = {
  'de-AT': {
    admin: {
      gdpr: {
        title: 'DSGVO-Anfragen',
        subtitle:
          'Bearbeitung von Daten-Export- und Konto-Löschungs-Anfragen gemäß Art. 15/17 DSGVO.',
        empty: 'Keine Anfragen gefunden.',
        filters: {
          status: 'Status',
          request_type: 'Typ',
          all: 'Alle',
        },
        columns: {
          id: 'ID',
          user_id: 'Benutzer-ID',
          type: 'Typ',
          status: 'Status',
          requested_at: 'Eingegangen',
          completed_at: 'Abgeschlossen',
          actions: 'Aktionen',
        },
        types: {
          export: 'Export',
          delete: 'Löschen',
        },
        status: {
          pending: 'Offen',
          approved: 'Genehmigt',
          rejected: 'Abgelehnt',
          completed: 'Abgeschlossen',
          failed: 'Fehlgeschlagen',
          cancelled: 'Abgebrochen',
        },
        actions: {
          approve: 'Genehmigen',
          reject: 'Ablehnen',
          download: 'ZIP herunterladen',
        },
        approve_dialog: {
          title: 'Anfrage genehmigen',
          message: 'Soll diese DSGVO-Anfrage genehmigt und sofort ausgeführt werden?',
          delete_warning:
            'ACHTUNG: Bei Genehmigung wird das Benutzerkonto unwiderruflich gelöscht bzw. anonymisiert. Diese Aktion kann nicht rückgängig gemacht werden.',
          confirm: 'Ja, genehmigen',
          cancel: 'Abbrechen',
        },
        reject_dialog: {
          title: 'Anfrage ablehnen',
          message: 'Bitte geben Sie einen Grund für die Ablehnung an:',
          reason_label: 'Grund',
          reason_placeholder: 'Grund der Ablehnung (mindestens 1 Zeichen) …',
          reason_required: 'Bitte einen Grund angeben.',
          confirm: 'Ablehnen',
          cancel: 'Abbrechen',
        },
        toast: {
          approved: 'Anfrage genehmigt.',
          rejected: 'Anfrage abgelehnt.',
          download_failed: 'Download fehlgeschlagen.',
          action_failed: 'Aktion fehlgeschlagen.',
        },
      },
    },
  },
} as const;
